<template>
  <div
    v-if="product !== null"
    class="product-item "
    @click.prevent="navigateToProduct(product.id)"
  >
    <div class="product-title">
      {{ product.name }}
    </div>

    <div>
      <div class="badge badge-primary  mr-2">
        REKLAM
      </div>
      <div class="badge badge-light mr-2">
        <img src="@/assets/images/icons/list-order.png">
        {{ product.type }}{{ buildLongId(product.id) }}
      </div>

      <div class="badge badge-light mr-2">
        <img src="@/assets/images/icons/calendar.png">
        {{ $t('dashboardCompany.key', {moment: getMoment(product.logTime)}) }}
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-3">
      <div class="d-flex align-items-center product-author">
        <img
          :src="getPhoto(product.user.photo,'thumbnailCropped')"
          class="img-thumbnail rounded-circle mr-2"
          style="height: 40px; width: 40px;"
        >
        <div>
          <span class="name">{{ product.user.name }}  {{ product.user.surname }}</span> <br>
          <span class="text-secondary company-name">
            {{ product.company.name }}
            {{ getCompanyFormat(product.company.format) }}
          </span>
        </div>
      </div>
      <div>
        <div class="d-flex align-items-center">
          <span
            v-if="product.status === 'ACTIVE'"
            class="badge bg-success mr-2"
          >Aktiv</span>
        </div>
      </div>
    </div>

    <p class="product-description">
      {{ product.description }}
    </p>
  </div>
</template>

<script>
import { buildLongId, getCompanyFormat, getPhoto } from "@/repositories/Utils";
import moment from "moment";

export default {
  name: 'ProductItem',
  props: {
    product: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY');
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    navigateToProduct(productId) {
      this.$router.push(`/dashboard/product/${productId}`);
    }
  }
}
</script>

<style lang="scss" scoped>
.product-item {
  cursor: pointer;
  padding: 20px;
  background: #faf4d3;
  border-radius: 6px;

  .product-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .product-description {
    color: #5D6B82;
  }

  .product-author {
    .name {
      font-size: 14px;
    }

    .company-name {
      font-size: 12px;
    }
  }

  &:hover {
    background-color: rgba(#2062FB, 0.05);

    .product-title {
      color: #2062FB;
    }
  }
}
</style>
